import type { WorkflowDefaults, WorkflowId } from "./types";

/** Spec default for labor time-waste percentage (all workflows). */
export const DEFAULT_LABOR_TIME_PERCENT = 45;

const UNTAPPED_ACTIONABLE_PERCENT: Record<WorkflowId, number> = {
  "custom-sales": 2,
  "field-service": 10,
  "high-volume": 5,
  "professional-services": 10,
};

export function getWorkflowDefaults(workflowId: WorkflowId): WorkflowDefaults {
  return {
    laborTimePercent: DEFAULT_LABOR_TIME_PERCENT,
    untappedActionablePercent: UNTAPPED_ACTIONABLE_PERCENT[workflowId],
  };
}
